class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.megaMenu = this.mainDetailsToggle.querySelector('.mega-menu');
    this.closeTimer = null;

    this.summary.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.close();
      } else {
        this.open();
      }
    });

    if (window.innerWidth >= 990) {
      const handleMouseEnter = () => {
        if (this.closeTimer) {
          clearTimeout(this.closeTimer);
          this.closeTimer = null;
        }
        this.open();
      };

      const handleMouseLeave = () => {
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => {
          if (this.mainDetailsToggle.matches(':hover')) return;
          if (this.megaMenu && this.megaMenu.matches(':hover')) return;
          this.close();
        }, 300);
      };

      this.summary.addEventListener('mouseenter', handleMouseEnter);
      this.addEventListener('mouseleave', handleMouseLeave);

      if (this.megaMenu) {
        this.megaMenu.addEventListener('mouseenter', handleMouseEnter);
        this.megaMenu.addEventListener('mouseleave', handleMouseLeave);
      }
    }
  }

  open() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  close() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    super.close();
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.matches(':hover')) return;
      if (this.megaMenu && this.megaMenu.matches(':hover')) return;
      if (!this.contains(document.activeElement)) this.close();
    }, 150);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }
}

customElements.define('header-menu', HeaderMenu);
